import React, { createContext, useState, useContext, useEffect } from 'react'
import { setSentryUser, clearSentryUser } from '@/v2/utils/sentry'

const AuthContext = createContext([])

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedIsLoggedIn = localStorage.getItem('isLoggedIn')
    const currentPath = window.location.pathname
    const authRoutes = [
      '/new-password',
      '/reset-password',
      '/login',
      '/insurance-form',
      '/health-history-form',
    ]

    if (authRoutes.some(route => currentPath.includes(route))) {
      return false
    }

    return storedIsLoggedIn !== null ? storedIsLoggedIn === 'true' : true
  })
  const [user, setUser] = useState(null)

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn)
  }, [isLoggedIn])

  useEffect(() => {
    if (user && isLoggedIn) {
      setSentryUser(user)
    } else {
      clearSentryUser()
    }
  }, [user, isLoggedIn])

  return (
    <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, user, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuthContext = () => {
  const { isLoggedIn, setIsLoggedIn, user, setUser } = useContext(AuthContext)

  return {
    isLoggedIn,
    setIsLoggedIn,
    user,
    setUser,
  }
}
